import { createRouter, createWebHistory } from 'vue-router';
import { scrollBehavior } from '@/utils/scrolling';
import routes from '@/routes';

export default function createRouterObject(base: string) {
  return createRouter({
    history: createWebHistory(base),
    routes,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    scrollBehavior,
  });
}
